<!--footer start-->
<footer class="agency footer2 p-b-0">
    <div class="container">
        <div class="row">
            <div class="col-12 col-md-3 set-first">
                <div class="logo-sec">
                    <div class="footer-title mobile-title">
                        <h3 class="text-white">{{ 'Footer.AboutUs' | translate }}</h3>
                    </div>
                    <div class="footer-contant">
                        <img [src]="logo" alt="EZane Mortgage logo" class="img-fluid footer-logo">
                        <div class="footer-para" itemscope itemtype="http://schema.org/PostalAddress">
                            <!-- <h6 class="text-white para-address">unice</h6> -->
                            <h6 class="text-white para-address" itemprop="streetAddress">E0523, BLOCK E,</h6>
                            <h6 class="text-white para-address" itemprop="streetAddress">SUNWAY GEO AVENUE 2,</h6>
                            <h6 class="text-white para-address" itemprop="streetAddress">JALAN LAGOON SELATAN,</h6>
                            <h6 class="text-white para-address" itemprop="postalCode addressRegion">47500 SUBANG JAYA,</h6>
                            <h6 class="text-white para-address" itemprop="addressCountry">Malaysia.</h6>
                            <h6 class="text-white para-address">+6011-10739345</h6>
                        </div>
                        <ul class="d-d-flex footer-social social">
                            <li class="footer-social-list">
                                <a href="https://www.facebook.com/EzaneMortgage" title="EZane Mortgage Facebook Page"><i class="fa fa-facebook" aria-hidden="true"></i></a>
                            </li>
                            <li class="footer-social-list">
                                <a href="https://www.instagram.com/ezanemortgage" title="EZane Mortgage Instagram"><i class="fa fa-instagram" aria-hidden="true"></i></a>
                            </li>
                            <!-- <li class="footer-social-list">
                                <a href="javascript:void()"><i class="fa fa-google" aria-hidden="true"></i></a>
                            </li> -->
                        </ul>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-4">
                <div class="fb-page" data-href="https://www.facebook.com/EzaneMortgage" data-adapt-container-width="true" data-show-facepile="true">
                    <blockquote cite="https://www.facebook.com/EzaneMortgage" class="fb-xfbml-parse-ignore">
                        <a href="https://www.facebook.com/EzaneMortgage" title="{{ 'title' | translate }}">Ezane Mortgage</a>
                    </blockquote>
                </div>
            </div>
            <div class="col-12 col-md-2">
                <div class="footer-title mobile-title">
                    <h3 class="text-white">{{ 'Footer.Sitemaps' | translate }}</h3>
                </div>
                <div class="footer-contant">
                    <h5 class="footer-headings">{{ 'Footer.Sitemaps' | translate }}</h5>
                    <div>
                        <ul class="footer-lists op-text" itemscope itemtype="http://schema.org/SiteNavigationElement">
                            <li class="">
                                <a routerLink="/" fragment="introduction" title="{{ 'Nav.Home' | translate }}" itemprop="name url">{{ 'Nav.Home' | translate }}</a>
                            </li>
                            <li class="">
                                <a routerLink="/" fragment="our-services" title="{{ 'Nav.OurServices' | translate }}" itemprop="name url">{{ 'Nav.OurServices' | translate }}</a>
                            </li>
                            <li class="">
                                <a routerLink="/" fragment="our-territory" title="{{ 'Nav.OurTerritory' | translate }}" itemprop="name url">{{ 'Nav.OurTerritory' | translate }}</a>
                            </li>
                            <li class="">
                                <a routerLink="/" fragment="our-achievements" title="{{ 'Nav.OurAchievements' | translate }}" itemprop="name url">{{ 'Nav.OurAchievements' | translate }}</a>
                            </li>
                            <li class="">
                                <a routerLink="/" fragment="meet-our-expert" title="{{ 'Nav.MeetOurExpert' | translate }}" itemprop="name url">{{ 'Nav.MeetOurExpert' | translate }}</a>
                            </li>
                            <li class="">
                                <a routerLink="/" fragment="E-Access" title="{{ 'Nav.E-Access' | translate }}" itemprop="name url">{{ 'Nav.E-Access' | translate }} <i class="fa fa-calculator" aria-hidden="true" style="font-size: 12px;"></i></a>
                            </li>
                            <li class="">
                                <a routerLink="/" fragment="latest-blog" title="{{ 'Nav.Blog' | translate }}" itemprop="name url">{{ 'Nav.Blog' | translate }}</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-3">
                <div class="footer-title mobile-title">
                    <h3 class="text-white">{{ 'Footer.Blog' | translate }}</h3>
                </div>
                <div class="footer-contant">
                    <h5 class="footer-headings">{{ 'Footer.Blog' | translate }}</h5>
                    <div>
                        <ul class="footer-lists op-text">
                            <li class="" *ngFor="let blog of blogService.blogs | slice: 0: 10" itemscope itemtype="http://schema.org/Blog">
                                <a [routerLink]="['/blog', blog.code]" [title]="blog.title" itemprop="name">{{ blog.title }}</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <!-- <div class="col-lg-2 col-md-3 col-sm-12">
                <div class="footer-title mobile-title">
                    <h3 class="text-white">Support</h3>
                </div>
                <div class="footer-contant">
                    <h5 class="footer-headings">Support</h5>
                    <div>
                        <ul class="footer-lists op-text">
                            <li class="">
                                <a href="javascript:void()">For Freelancers</a>
                            </li>
                            <li class="">
                                <a href="javascript:void()">For Companies</a>
                            </li>
                            <li class="">
                                <a href="javascript:void()">For Business</a>
                            </li>
                            <li class="">
                                <a href="javascript:void()">General Help</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div> -->
            <!-- <div class="col-lg-3 col-md-12 col-sm-12 set-last">
                <div class="footer-title mobile-title">
                    <h3 class="text-white">Post Tags</h3>
                </div>
                <div class="footer-contant">
                    <h5 class="footer-headings">Post Tags</h5>
                    <div class="link-btns">
                        <ul>
                            <li class="buttons">
                                <a href="javascript:void()">app</a>
                            </li>
                            <li class="buttons">
                                <a href="javascript:void()">business</a>
                            </li>
                            <li class="buttons">
                                <a href="javascript:void()">corporation</a>
                            </li>
                            <li class="buttons">
                                <a href="javascript:void()">creative</a>
                            </li>
                            <li class="buttons">
                                <a href="javascript:void()">design</a>
                            </li>
                            <li class="buttons">
                                <a href="javascript:void()">fashion</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div> -->
        </div>
        <!--footer end-->
        <!-- <div class="row">
            <div class="col-12">
                <div class="brand-container">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="link-horizontal">
                                <ul>
                                    <li>
                                        <a href="javascript:void()" class="center-content">
                                            <img src="assets/images/agency/brand/1.png" alt="" class="img-fluid">
                                        </a>
                                    </li>
                                    <li class="borders-right p-0"></li>
                                    <li>
                                        <a href="javascript:void()" class="center-content">
                                            <img src="assets/images/agency/brand/2.png" alt="" class="img-fluid">
                                        </a>
                                    </li>
                                    <li class="borders-right p-0"></li>
                                    <li>
                                        <a href="javascript:void()" class="center-content">
                                            <img src="assets/images/agency/brand/3.png" alt="" class="img-fluid">
                                        </a>
                                    </li>
                                    <li class="borders-right p-0"></li>
                                    <li>
                                        <a href="javascript:void()" class="center-content">
                                            <img src="assets/images/agency/brand/4.png" alt="" class="img-fluid">
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="list float-right">
                                <ul>
                                    <li>
                                        <a href="javascript:void()">
                                            <img src="assets/images/agency/brand/paytm-1.png" alt=""
                                                 class="img-fluid">
                                        </a>
                                    </li>
                                    <li>
                                        <a href="javascript:void()">
                                            <img src="assets/images/agency/brand/paytm-2.png" alt=""
                                                 class="img-fluid">
                                        </a>
                                    </li>
                                    <li>
                                        <a href="javascript:void()">
                                            <img src="assets/images/agency/brand/paytm-3.png" alt=""
                                                 class="img-fluid">
                                        </a>
                                    </li>
                                    <li>
                                        <a href="javascript:void()">
                                            <img src="assets/images/agency/brand/paytm-4.png" alt=""
                                                 class="img-fluid">
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->
    </div>
</footer>
<!--footer end-->
<!--copyright start-->
<div class="agency copyright inner-page" *ngIf="url!='/portfolio/portfolio-parallex' && url!='/portfolio/centered-slide' && url!='/portfolio/multiple-carousel' && url!='/portfolio/vertical-slide'">
    <div class="container">
            <div class="row">
                <div class="col-sm-6">
                    <div class="link-horizontal">
                        <ul>
                            <li>
                                <a class="copyright-text" routerLink="/privacy-policy" title="Privacy Policy">Privacy Policy</a>
                            </li>
                            <!-- <li>
                                <a class="copyright-text" href="javascript:void()">Terms &amp; Conditions</a>
                            </li> -->
                        </ul>
                    </div>
                </div>
                <div class="col-sm-6">
                    <div>
                        <h6 class="copyright-text text-white text-right">Copyright ©{{date | date: 'yyyy'}} EZane Mortgage</h6>
                    </div>
                </div>
            </div>
        </div>
</div>
<!--copyright start-->    
<app-tap-to-top *ngIf="url!='/portfolio/centered-slide' && url!='/portfolio/multiple-carousel' && url!='/portfolio/vertical-slide'"></app-tap-to-top>

